var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 16,
    viewBox: "0 0 100 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4375 0.966119C41.2234 1.26674 29.2916 4.03019 18.068 7.76823C17.163 8.06969 15.9706 8.46708 15.4184 8.65132C7.97159 11.1359 3.96664 12.7027 1.16329 14.2284C0.0692323 14.8238 -0.0247609 14.896 0.00419012 15.1185C0.0464732 15.4432 0.224475 15.393 2.25456 14.4846C4.35527 13.5445 6.23815 12.8619 11.402 11.1685C28.6608 5.50857 36.7219 3.43364 45.764 2.32381C47.5359 2.1063 50.366 2.14418 50.366 2.38536C50.366 2.70753 48.5909 3.80625 44.481 6.02797C39.4248 8.76126 36.3468 10.5744 36.0742 10.9801C35.6084 11.6733 36.1207 12.1735 37.2293 12.1079C37.8628 12.0705 38.0066 12.0421 40.9109 11.3825C49.2496 9.48858 54.5788 8.52736 61.8014 7.61452C72.8004 6.22435 79.8084 5.71151 92.9838 5.33246C97.718 5.1963 97.9629 5.1773 98.8367 4.87917C99.1735 4.76425 99.5758 4.65195 99.7307 4.62954C100.094 4.57716 100.089 4.51014 99.7195 4.46072C99.5584 4.43917 99.1882 4.33634 98.8967 4.23217C98.1781 3.97532 97.7016 3.9619 93.5974 4.08283C79.8384 4.48816 72.5988 5.00653 62.1082 6.33745C56.591 7.03739 54.1325 7.41771 50.115 8.19281C47.3685 8.72265 40.1191 10.2652 39.1036 10.5358C38.5495 10.6834 40.9547 9.29068 45.1793 7.01766C50.5232 4.14238 51.5871 3.36146 51.592 2.31094C51.5976 1.12632 50.6263 0.811926 47.4375 0.966119Z",
    fill: "#292B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.14333de8375e6d13300266979596b832.svg";
export { ForwardRef as ReactComponent };